import { useState, useEffect } from 'react';
import { edicaoApi } from '../lib/api';

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

export const EDICAO_DEFAULT = {
  ano: 2027,
  nome: 'Encontro de Casais Kairós 2027',
  tema: 'Uma nova oportunidade de fortalecer o amor',
  data_inicio: '2027-11-12',
  data_fim: '2027-11-15',
  local_confirmado: true,
  local_nome: 'Hotel Fazenda Minuano',
  local_cidade: 'Ji-Paraná/RO',
  pre_inscricoes_abertas: true,
  status_lote: 'em_breve',
  lote_mensagem: 'O primeiro lote de inscrições estará disponível em breve.',
  whatsapp_contato: '5569999999999',
};

export const formatPeriodo = (inicio, fim) => {
  try {
    const [ai, mi, di] = inicio.slice(0, 10).split('-').map(Number);
    const [, , df] = fim.slice(0, 10).split('-').map(Number);
    return `${String(di).padStart(2, '0')} a ${String(df).padStart(2, '0')} de ${MESES[mi - 1]} de ${ai}`;
  } catch {
    return 'Data a confirmar';
  }
};

export const localLabel = (edicao) =>
  edicao?.local_confirmado && edicao?.local_nome
    ? `${edicao.local_nome}${edicao.local_cidade ? ` • ${edicao.local_cidade}` : ''}`
    : 'Local a confirmar';

export const useEdicao = () => {
  const [edicao, setEdicao] = useState(EDICAO_DEFAULT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    edicaoApi.get()
      .then((res) => setEdicao({ ...EDICAO_DEFAULT, ...res.data }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { edicao, loading, periodo: formatPeriodo(edicao.data_inicio, edicao.data_fim), local: localLabel(edicao) };
};
